import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { formatToDecimals } from '@utils/utils';

export default [
  {
    label: 'Kód artiklu',
    field: 'number',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Kategorie',
    field: 'category.name',
    displayField: 'category',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Měrná jednotka',
    field: 'measureUnit.name',
    displayField: 'measureUnit',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Jednotková cena s DPH',
    field: 'unitPrice',
    type: ColumnType.NUMBER,
    width: 200,
    mapper: v => formatToDecimals(v)
  },
  {
    label: 'Výstrojná lhůta v měsících',
    field: 'daysLimit',
    type: ColumnType.NUMBER,
    width: 200
  },
  {
    label: 'Popis',
    field: 'description',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Vytvořeno dne',
    field: 'created',
    type: ColumnType.DATE,
    width: 200
  },
  {
    label: 'Vytvořil',
    field: 'createdBy.fullName',
    displayField: 'createdBy',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Sklad',
    field: 'warehouse.name',
    displayField: 'warehouse',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/inventoryCards/_inventoryCardsColumns.ts